import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { formatCurrency, formatPercentage } from '@/lib/utils/format';
import type { TopSeller } from '../types/analytics.types';

interface TopSellersTableProps {
  sellers: TopSeller[];
}

export function TopSellersTable({ sellers }: TopSellersTableProps) {
  if (sellers.length === 0) {
    return (
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Top Vendedores</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-32 flex items-center justify-center text-muted-foreground text-sm">
            Sin datos de vendedores para este periodo
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Top Vendedores</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="border rounded-lg overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nombre</TableHead>
                <TableHead className="text-right">Cotizaciones</TableHead>
                <TableHead className="text-right">Ingresos Aprobados</TableHead>
                <TableHead className="text-right">Margen Promedio</TableHead>
                <TableHead className="text-right">Win Rate</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {sellers.slice(0, 10).map((seller) => (
                <TableRow key={seller.userId}>
                  <TableCell className="font-medium">{seller.name}</TableCell>
                  <TableCell className="text-right">{seller.totalQuotes}</TableCell>
                  <TableCell className="text-right font-semibold">
                    {formatCurrency(seller.approvedRevenue)}
                  </TableCell>
                  <TableCell className="text-right">
                    <span className={seller.avgMargin >= 20 ? 'text-green-600' : 'text-amber-600'}>
                      {formatPercentage(seller.avgMargin)}
                    </span>
                  </TableCell>
                  <TableCell className="text-right">
                    <span className={seller.winRate >= 50 ? 'text-green-600' : 'text-amber-600'}>
                      {formatPercentage(seller.winRate)}
                    </span>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
